import React from "react";
import { ClipboardList, Bot, Rocket, BarChart3 } from "lucide-react";
import Reveal from "./Reveal";

const STEPS = [
    { icon: ClipboardList, title: "Заповніть анкету", desc: "10 питань про бізнес. Без технічного жаргону." },
    { icon: Bot, title: "AI будує кампанію", desc: "Ключові слова, тексти, бюджет — готово за 30 секунд." },
    { icon: Rocket, title: "Запускаєте вручну", desc: "Копіюєте готову структуру в Google Ads по інструкції." },
    { icon: BarChart3, title: "Отримуєте поради щотижня", desc: "Завантажуєте звіт — AI каже що змінити конкретно." },
];

export const HowItWorks = () => {
    return (
        <section className="section" data-testid="how-it-works-section">
            <div className="container-mx">
                <Reveal>
                    <h2 className="font-display font-extrabold text-text-primary leading-[1.02]" style={{ fontSize: "clamp(36px, 5vw, 56px)", letterSpacing: "-0.025em" }}>
                        20 хвилин. <span className="text-secondary-c">І реклама запущена.</span>
                    </h2>
                </Reveal>

                <div className="mt-16 relative">
                    {/* Horizontal connector line */}
                    <div className="hidden md:block absolute top-[28px] left-[40px] right-[40px] h-[1px] bg-border" />

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6 relative">
                        {STEPS.map((s, i) => {
                            const Icon = s.icon;
                            return (
                                <Reveal key={i} delay={i * 0.08}>
                                    <div className="relative">
                                        <div className="w-14 h-14 rounded-full glass flex items-center justify-center relative z-10" style={{ borderColor: "rgba(109,94,248,0.35)" }}>
                                            <Icon size={22} className="text-primary-c" />
                                        </div>
                                        <div className="mt-5 font-mono text-xs text-faint-c">КРОК 0{i + 1}</div>
                                        <h3 className="mt-2 font-display font-bold text-xl text-text-primary">{s.title}</h3>
                                        <p className="mt-2 text-sm text-secondary-c leading-relaxed">{s.desc}</p>
                                    </div>
                                </Reveal>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
